/** The host's limit of people; 0 or less counts as no limit. */
export function placesLimit(capacity: number | null | undefined): number | null {
  return capacity != null && capacity > 0 ? capacity : null
}

/** Places still free (people incl. companions), or null without a limit. */
export function placesLeft(acceptedPeople: number, capacity: number | null | undefined) {
  const limit = placesLimit(capacity)
  return limit === null ? null : Math.max(0, limit - acceptedPeople)
}

/** Whether accepting a request with these companions still fits the free places. */
export function requestFits(
  companions: number,
  acceptedPeople: number,
  capacity: number | null | undefined,
): boolean {
  const left = placesLeft(acceptedPeople, capacity)
  return left === null || 1 + companions <= left
}
